module.exports = __webpack_public_path__ + "img/face-tongue-sweat.e76c6d15.svg";